import React, {Component} from 'react';
import '../assets/stylesheets/Countdown.scss';
import Game3Store from "../stores/Game3Store";

export default class CountdownGame3 extends Component {

    constructor(props) {
        super(props);
        this.interval = null;

        this.state = {
            change: false
        }
    }

    componentWillMount() {
        this.startTimer();
    }

    componentWillReceiveProps() {
        clearInterval(this.interval);
    }

    componentWillUnmount () {
       this.stopTimer();
    }

    startTimer = () => {
        Game3Store.seconds = Game3Store.seconds - 1;
        this.setState({change: true});

        this.interval = setInterval(() => {

            if  (  Game3Store.seconds <= 0 && Game3Store.minutes <= 0) {
                clearInterval(this.interval);
            } else if ( Game3Store.seconds <= 0 ) {
                Game3Store.minutes = Game3Store.minutes - 1;
                Game3Store.seconds = 59;
            } else {
                Game3Store.seconds = Game3Store.seconds - 1;
            }

            this.setState({change: !this.state.change});

        }, 1000);
    }

    stopTimer = () => {
        if( this.interval ) {
            clearInterval(this.interval);
        }
    }

    render() {

        if ( Game3Store.seconds <= 0 && Game3Store.minutes <= 0) {
            this.stopTimer();
            return (
                <div>
                    <button className="timer">The time is over</button>
                </div>
            );
        } else {
            return (
                <div>
                    <button className="timer" >{Game3Store.minutes} : {Game3Store.seconds < 10 ? "0"+Game3Store.seconds : Game3Store.seconds}</button>
                </div>
            );
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/CountdownGame3.js